const Subjects = [
  { subject: "Software / IT", value: 0.2 },
  { subject: "Legal", value: 0.21 },
  { subject: "Marketing", value: 0.19 },
  { subject: "Medical", value: 0.28 },
  { subject: "Scientific", value: 0.22 },
  { subject: "Technical", value: 0.22 },
  { subject: "Gaming", value: 0.24 },
  { subject: "Ad-word", value: 0.19 },
  { subject: "Cryto / Forex", value: 0.2 },
  { subject: "Automotive", value: 0.19 },
  { subject: "Finance", value: 0.2 },
  { subject: "Patents", value: 0.2 },
  { subject: "Mobile Apps", value: 0.2 },
  { subject: "Tourism", value: 0.2 },
  { subject: "Elearning / Training", value: 0.2 },
];

export default Subjects;
